import { Outlet, Link, useLocation } from "react-router-dom";
import { TopBar } from "./TopBar.js";
import { RouteErrorBoundary } from "./RouteErrorBoundary.js";

/** A breadcrumb segment; the last is the current location (no link). */
export interface Crumb {
  readonly label: string;
  readonly to?: string;
}

/** Drill context (E8.2-AC3): Portfolio › Program › Project. */
export function Breadcrumb({ items }: { items: readonly Crumb[] }): React.ReactNode {
  return (
    <nav className="crumb" aria-label="Breadcrumb">
      {items.map((crumb, i) => (
        <span key={`${crumb.label}-${i}`}>
          {i > 0 ? " › " : null}
          {crumb.to ? <Link to={crumb.to}>{crumb.label}</Link> : <b>{crumb.label}</b>}
        </span>
      ))}
    </nav>
  );
}

function Footer(): React.ReactNode {
  return (
    <div className="foot">
      <span>SeneSight · Delivery Intelligence</span>
      <span>© 2026 SeneTek LLC</span>
    </div>
  );
}

/** Authenticated app frame: the top bar, the routed page, and the footer. */
export function Shell(): React.ReactNode {
  const { pathname } = useLocation();
  return (
    <div className="app">
      <TopBar />
      <div className="wrap">
        {/* The boundary sits INSIDE the shell, around the outlet only: a screen that throws is
            contained to this area, and the nav above it survives so the user can leave. Keyed on
            the path so navigating away clears the failure. */}
        <RouteErrorBoundary resetKey={pathname}>
          <Outlet />
        </RouteErrorBoundary>
      </div>
      <Footer />
    </div>
  );
}
